/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from "@angular/core";

@Component({
  selector: "app-common-alert-modal",
  templateUrl: "./common-alert-modal.component.html",
  styleUrls: ["./common-alert-modal.component.scss"],
})
export class CommonAlertModalComponent implements OnChanges {
  @Input() title = "";
  @Input() message = "";
  @Input() cancelBtnTitle = "";
  @Input() actionBtnTitle = "";
  @Input() isModalOpen = false;
  @Input() actionType = "";
  @Input() placeholderObject: any;
  @Input() hideSecondaryBtn = "";
  @Output()
  isModalResponseClicked = new EventEmitter<any>();
  translationData: any;
  showCheckBox: boolean = false;
  isChecked: boolean = true;

  onCancel() {
    this.isModalResponseClicked.emit({ action: false });
  }

  onAction() {
    this.isModalResponseClicked.emit({
      action: true,
      actionType: this.actionType,
      checkBoxValue:
        this.actionType === "FLORA_FAUNA_CONFIRMATION" ? this.isChecked : false,
    });
  }

  ngOnChanges(): void {
    if (this.actionType === "FLORA_FAUNA_CONFIRMATION") {
      this.showCheckBox = true;
    }
  }
}
